<template>
  <div>
    <h1>Profile</h1>
    <linear-loader
      v-if="apiStatus === 1"
      text="Loading your profile informaion"
    />
    <div v-else-if="apiStatus === 2" class="row">
      <div class="sm-12 md-4">
        <div class="img profile__img">
          <img
            v-if="user.img"
            :src="user.img"
            :alt="`${user.username}'s profile picture`"
          />
          <div v-else class="placeholder img">
            <img
              :src="require('@/assets/images/default_avatar_bg.jpg')"
              alt="default avatar"
            />
            <div class="avatar-icon">
              <span>{{ user.username[0] }}</span>
            </div>
          </div>

          <button class="radial profile__img-edit hide">
            <i class="material-icons">image</i>
          </button>
        </div>
      </div>
      <div class="sm-12 md-8 profile__info">
        <status-info
          v-if="showSuccess"
          status="success"
          :timeout="statusTimeout"
          :message="userUpdateMessage"
        />
        <status-info
          v-else-if="showError"
          status="error"
          :timeout="statusTimeout"
          :message="userUpdateMessage"
        />
        <form @submit.prevent="updateUser" ref="form">
          <!-- {{ user }}<br />
          {{ email }} -->
          <div class="row">
            <input-field
              class="sm-6 pr-2"
              label="first name"
              id="firstName"
              :value="firstName"
              :error="errors.firstName"
            />
            <input-field
              class="sm-6 pl-2"
              label="last name"
              id="lastName"
              :value="lastName"
              :error="errors.lastName"
            />
          </div>
          <input-field
            label="username"
            :value="username"
            :error="errors.username"
          />
          <input-field
            label="email"
            type="email"
            :value="email"
            :error="errors.email"
          />
          <input-field
            label="phone number"
            id="phoneNumber"
            :value="phoneNumber"
            :error="errors.phoneNumber"
          />

          <div class="row hcenter">
            <button
              type="submit"
              class="waves has-icon"
              :class="userUpdateApiStatus === 1 ? 'loading' : ''"
            >
              <i class="material-icons">edit</i>
              update
            </button>
          </div>
        </form>
      </div>
    </div>
    <div v-else-if="apiStatus === 3" class="row hcenter">
      <div>
        <h2 class="text-red">Error</h2>
        <p>Could not retrieve your profile</p>
        <p>Make sure you have an active internet connection and is logged in</p>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-undef */

import { mapGetters } from "vuex";

import InputField from "@/components/InputField.vue";
import StatusInfo from "@/components/StatusInfo.vue";
import LinearLoader from "@/components/loaders/LinearLoader.vue";

export default {
  name: "ProfileDetails",
  components: {
    InputField,
    StatusInfo,
    LinearLoader,
  },
  computed: {
    ...mapGetters({
      user: "User/getDetails",
      apiStatus: "User/getLoadingStatus",

      userUpdateApiStatus: "User/updateUserStatus",
      userUpdateMessage: "User/updateUserMessage",
      userUpdateError: "User/updateUserError",
    }),
  },

  data() {
    return {
      firstName: "",
      lastName: "",
      username: "",
      email: "",
      phoneNumber: "",

      errors: {
        firstName: "",
        lastName: "",
        username: "",
        email: "",
        phoneNumber: "",
      },

      showSuccess: false,
      showError: false,
      statusTimeout: 5000,
      statusTimeoutOffset: 1000,
    };
  },
  watch: {
    user(user) {
      // console.log('User watch: ', user)
      this.handleUserFields(user);
    },
  },
  mounted() {
    // T.modal();
    T.waves();

    this.handleUserFields();
  },
  methods: {
    handleUserFields(user = undefined) {
      user = user ?? this.user;
      // console.log('User Handle: ', user)

      this.firstName = user.firstName;
      this.lastName = user.lastName;
      this.username = user.username;
      this.email = user.email;
      this.phoneNumber = user.phoneNumber;
    },
    validate() {
      // TODO do some proper validation
      let success = true;

      if (!this.email) {
        this.errors.email = "Email is required";
        success = false;
      } else {
        this.errors.email = "";
      }
      if (!this.phoneNumber) {
        this.errors.phoneNumber = "Phone Number is required";
        success = false;
      } else {
        this.errors.phoneNumber = "";
      }
      if (!this.username) {
        this.errors.username = "Username is required";
        success = false;
      } else {
        this.errors.username = "";
      }

      // patterns

      return success;
    },
    updateUser(e) {
      // console.clear()
      const formData = new FormData(e.target);

      const firstName = formData.get("firstName");
      const lastName = formData.get("lastName");
      const username = formData.get("username");
      const email = formData.get("email");
      const phoneNumber = formData.get("phoneNumber");

      this.firstName = firstName;
      this.lastName = lastName;
      this.username = username;
      this.email = email;
      this.phoneNumber = phoneNumber;

      if (!this.validate()) return;

      const payload = {
        firstName,
        lastName,
        username,
        email,
        phoneNumber,
      };

      this.$store.dispatch("User/update", payload).then(() => {
        if (this.userUpdateApiStatus === 2) {
          this.showSuccess = true;

          setTimeout(() => {
            this.showSuccess = false;
          }, this.statusTimeout + this.statusTimeoutOffset);
        } else if (this.userUpdateApiStatus === 3) {
          this.showError = true;

          for (const field in this.userUpdateError) {
            this.errors[field] = this.userUpdateError[field][0];
          }

          setTimeout(() => {
            this.showError = false;
          }, this.statusTimeout + this.statusTimeoutOffset);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.profile__img {
  position: relative;
  margin-bottom: 2rem;

  img,
  .img,
  .placeholder {
    min-height: 320px;

    @include tablet-and-up {
      min-height: 280px;
    }
  }

  .placeholder {
    position: relative;
    overflow: hidden;
    border-radius: 5px;

    .avatar-icon {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -60%);
      width: 150px;
      height: 150px;
      display: grid;
      place-items: center;
      border-radius: 50%;
      color: $text-color;
      font-size: 5rem;
      background-color: $blue;
      text-transform: uppercase;

      @supports(backdrop-filter: blur()) {
        color: inherit;
        background-color: transparentize($blue, $amount: .85);
        backdrop-filter: blur(20px);
        border: 1px solid #ffffff30;
        box-shadow: 2px 3px 10px #00000040;
      }
    }

    img {
      filter: blur(5px);
      transform: scale(1.1);
    }
  }

  &-edit {
    position: absolute;
    left: 50%;
    bottom: 1rem;
    transform: translateX(-50%);
  }
}
.profile__info {
  @include tablet-and-up {
    padding-left: 1rem;
  }
}
</style>